import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-646dccef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  class: "property-lookup-container",
  "data-bind": "dxTextBox: {}"
}
const _hoisted_3 = { class: "verify-button" }

import { ref, inject, PropType, watch } from "vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import DxTextBox from "devextreme-vue/text-box";
import DxButton from "devextreme-vue/button";
import { CountryCodes } from "@/enums/system/CountryCodes";
import { MprnLookupResponse } from "@/types/switches/MprnLookupResponse";
import { Address } from "@/types/generic/Address";
import { FieldSize } from "@/enums/system/FieldSize";
import { DxRequiredRule, DxNumericRule } from "devextreme-vue/validator";
import { DxValidator } from "devextreme-vue";
import { ValidatedEvent } from "devextreme/ui/validator";


export default /*#__PURE__*/_defineComponent({
  __name: 'mprn-property-lookup',
  props: {
  /**
   * Determines whether the control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * The address object containing details about the location.
   * @type {Address}
   * @required
   */
  address: {
    type: Object as PropType<Address>,
    required: true,
  },
  /**
   * The validation group identifier for managing form validations.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the control is numeric field.
   * @type {boolean}
   * @default false
   */
  numericalField: {
    type: Boolean,
    required: false,
  },
  /**
   * An optional message to display when the input is invalid.
   * @type {string}
   * @optional
   */
  invalidMessage: {
    type: String,
    required: false,
  },
  /**
   * Determines whether the MPRN Lookup is disabled.
   * @type {boolean}
   * @default false
   */
  disableMprnLookup: {
    type: Boolean,
    default: false,
  },
  mprn: {
    /**
     * The Meter Point Reference Number (MPRN), typically used for gas meters.
     * @type {string}
     * @default ''
     */
    type: String,
    default: "",
  },
},
  emits: [
  "propertyFound",
  "searchFailed",
  "mprnUpdated",
  "update:disableMprnLookup",
],
  setup(__props, { emit }) {

const props = __props;





const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const mprn = ref("");
const propertyDetails = ref<MprnLookupResponse>();

const requestBody = ref({
  countryCode: CountryCodes.ireland,
  postCode: "",
  propertyName: "",
  street: "",
  locality: "",
  town: "",
  region: "",
});

watch(
  () => props.address,
  () => {
    requestBody.value.propertyName = props.address.propertyName;
    requestBody.value.street = props.address.street;
    requestBody.value.locality = props.address.locality;
    requestBody.value.town = props.address.town;
    requestBody.value.region = props.address.region;
    requestBody.value.postCode = props.address.postCode;
  },
);

const getPropertyAddress = async () => {
  try {
    propertyDetails.value = await apiClient.httpPost(
      `app/utilityswitching/mprnlookup/${mprn.value}`,
      requestBody.value,
    );
  } catch (err) {
    emit("searchFailed");
  }
};

const searchClick = async () => {
  // This avoids unnecessary API calls
  if (props.readOnly || !mprn.value.match(/^[0-9]{11}$/)) {
    emit("searchFailed");
    return;
  }

  /* Set searching flag so only 1 lookup can be processed at a time
   * this prevents users from seeing multiple mprn confirmation alerts */
  searching.value = true;

  propertyDetails.value = undefined;

  await getPropertyAddress();

  if (propertyDetails.value && mprn.value) {
    emit("propertyFound", propertyDetails.value, mprn.value);
  }

  searching.value = false;
};

const searching = ref(false);

/** Custom validation configuration to override DevExpress default validation method */
const adapterConfig = {
  getValue: () => {
    return mprn.value;
  },
  applyValidationResults: (e: ValidatedEvent) => {
    isValid.value = !!e.isValid;

    // Construct list of validation errors to be displayed to the user when they hover over the field
    validationErrors.value =
      !e.isValid && e.brokenRule?.message ? e.brokenRule.message : "";
  },
  validationRequestsCallbacks: [],
};

const validationErrors = ref("");

const isValid = ref(true);

const mprnUpdated = () => {
  emit("mprnUpdated");
};

watch(
  () => props.mprn,
  () => {
    mprn.value = props.mprn;
  },
  { immediate: true },
);

const onFocusOut = () => {
  mprn.value = mprn.value.trim();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DxTextBox), {
        value: mprn.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((mprn).value = $event)),
        width: _unref(FieldSize).Large,
        isValid: isValid.value,
        hint: validationErrors.value,
        "max-length": "11",
        onValueChanged: mprnUpdated,
        onFocusOut: _cache[1] || (_cache[1] = ($event: any) => (onFocusOut()))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxValidator), {
            adapter: adapterConfig,
            "validation-group": props.validationGroup
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxRequiredRule)),
              (props.numericalField)
                ? (_openBlock(), _createBlock(_unref(DxNumericRule), {
                    key: 0,
                    message: props.invalidMessage
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["validation-group"])
        ]),
        _: 1
      }, 8, ["value", "width", "isValid", "hint"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DxButton), {
        text: "Verify",
        onClick: searchClick
      })
    ])
  ], 64))
}
}

})